// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__iEiBG{
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    height: 48px;
    padding: 0 25px;
    color: #40798C;
    background-color: #FFFFFF;
    font-family: 'Gotham Medium', serif;
    text-decoration: none;
    border: 1px solid #40798C66;
    border-radius: 500px;
    outline: none;
    cursor: pointer;
}
.Button_dark__U\\+P1G{
    color: #FFFFFF;
    background-color: #40798C;
}
.Button_disabled__gCPRN{
    background-color: #1F363D1A;
    border: none;
}
.Button_image__ux2Yx{
    margin-right: 8px;
    height: 20px;
    width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Button.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mCAAmC;IACnC,qBAAqB;IACrB,2BAA2B;IAC3B,oBAAoB;IACpB,aAAa;IACb,eAAe;AACnB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf","sourcesContent":[".button{\n    display: flex;\n    position: relative;\n    justify-content: center;\n    align-items: center;\n    height: 48px;\n    padding: 0 25px;\n    color: #40798C;\n    background-color: #FFFFFF;\n    font-family: 'Gotham Medium', serif;\n    text-decoration: none;\n    border: 1px solid #40798C66;\n    border-radius: 500px;\n    outline: none;\n    cursor: pointer;\n}\n.dark{\n    color: #FFFFFF;\n    background-color: #40798C;\n}\n.disabled{\n    background-color: #1F363D1A;\n    border: none;\n}\n.image{\n    margin-right: 8px;\n    height: 20px;\n    width: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__iEiBG`,
	"dark": `Button_dark__U+P1G`,
	"disabled": `Button_disabled__gCPRN`,
	"image": `Button_image__ux2Yx`
};
export default ___CSS_LOADER_EXPORT___;
